import React, { useState } from "react";
import "../../styles/desktop/agendamento.css";
import ListaAgendados from "../Lista-de-Agendamentos/listaAgendados";
import { Agendamento } from "../../API/AgendarEvento";

function TelaTemporizacao() {
  const [grupoLuz, setGrupoLuz] = useState("Postes");
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState("1R10");
  const [offValueLuz, setOffValueLuz] = useState("1R00");

  const [grupoExaustor, setGrupoExaustor] = useState("");
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState("1W10");
  const [offValueExaustor, setOffValueExaustor] = useState("1W00");

  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleSelectChange = (e, setGrupo, setOnValue, setOffValue) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setGrupo(e.target.value);
    setOnValue(selectedOption.getAttribute('data-on'));
    setOffValue(selectedOption.getAttribute('data-off'));
  };

  const temporizar = async () => {
    if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      alert("Preencha todos os campos.");
      return;
    } else if (grupoLuz !== "" && inicioLuz !== "" && fimLuz !== "" && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento apenas de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
    } else if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && grupoExaustor !== "" && inicioExaustor !== "" && fimExaustor !== "") {
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    } else {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
  
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      alert("Agendamento de exaustores salvo.");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    }
    // Alterna o valor de refreshFlag para forçar a re-renderização de ListaAgendados
    setRefreshFlag(!refreshFlag);
  };

  return (
    <div id="TelaTemporizacao">
      <div id="temporizacao">
        <h1>Agendamentos diários</h1>
        <div id="temporizacaoContent">
          <div id="temporizacaoContent1">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1">
              Grupo
              <select id="selectGrupoLuz" onChange={(e) => handleSelectChange(e, setGrupoLuz, setOnValueLuz, setOffValueLuz)}>
                <option value="Postes" data-on="1R10" data-off="1R00">Postes</option>
                <option value="Muro Acesso Veículos" data-on="1H10" data-off="1H00">Muro Acesso Veículos</option>
                <option value="Logo + LED" data-on="1E10" data-off="1E00">Logo + LED</option>
                <option value="Jardim Coqueiro" data-on="1E10" data-off="1E00">Jardim Coqueiro</option>
                <option value="Substação" data-on="1C10" data-off="1C00">Substação</option>
                <option value="Quadra" data-on="1A10 - 1B10" data-off="1A00 - 1A00">Quadra</option>
                <option value="Pergolado" data-on="1F10" data-off="1F00">Pergolado</option>
                <option value="Piscina Grande" data-on="1M10" data-off="1M00">Piscina Grande</option>
                <option value="Piscina Infanti" data-on="1L10" data-off="1L00">Piscina Infantil</option>
                <option value="Floreira Piscina"  data-on="1O10" data-off="1O00">Floreira Piscina</option>
                <option value="Escada Poste"  data-on="1N10" data-off="1N00">Escada Poste</option>
                <option value="Floreira + Muro"  data-on="1N10" data-off="1N00">Floreira + Muro</option>
                <option value="Floreira + Espaço Kids"  data-on="1K10" data-off="1K00">Floreira + Espaço Kids</option>
                <option value="Pergolado Mãe"  data-on="data-on" data-off="data-off">Pergolado Mãe</option>
                <option value="Ac. Piscina. Iluminação varanda"  data-on="1P10" data-off="1P00">Ac. Piscina. Iluminação varanda</option>
                <option value="Hall Elevador" data-on="1P10" data-off="1P00">Hall Elevador</option>
                <option value="Muro Piscina" data-on="1G10" data-off="1G00">Muro Piscina</option>
                <option value="Hall Entrada Social" data-on="1T10" data-off="1T00">Hall Entrada Social</option>
                <option value="Iluminação Externa" data-on="1D10" data-off="1D00">Iluminação Externa</option>
                <option value="Hall Terreol" data-on="1S10" data-off="1S 00">Hall Terreo</option>
                {/* Outras opções */}
              </select>
              <label htmlFor="temporizacao1">Inicio</label>
              <input type="time" id="inicioLuz" name="temporizacao1" value={inicioLuz} onChange={(e) => setInicioLuz(e.target.value)} />
              <label htmlFor="temporizacao2">Fim</label>
              <input type="time" id="fimLuz" name="temporizacao2" value={fimLuz} onChange={(e) => setFimLuz(e.target.value)} />
            </div>
          </div>
          <div id="temporizacaoContent2">
            <h2>Exaustor</h2>
            <div id="temporizacaoContent2-1">
              Grupo
              <select id="selectGrupoExaustores" onChange={(e) => handleSelectChange(e, setGrupoExaustor, setOnValueExaustor, setOffValueExaustor)}>
                <option value="Exaustor 1 e 2" data-on="1W10" data-off="1W00">Exaustor 1 e 2</option>
                <option value="Exaustor 3 e 4" data-on="1X10" data-off="1X00">Exaustor 3 e 4</option>
                <option value="Exaustor Goumert" data-on="1V10" data-off="1V00">Exaustor Goumert</option>
              </select>
              <label htmlFor="temporizacao4">Inicio</label>
              <input type="time" id="inicioExaustor" name="temporizacao3" value={inicioExaustor} onChange={(e) => setInicioExaustor(e.target.value)} />
              <label htmlFor="temporizacao2">Fim</label>
              <input type="time" id="fimExaustor" name="temporizacao4" value={fimExaustor} onChange={(e) => setFimExaustor(e.target.value)} />
            </div>
          </div>
        </div>
        <button id="btnSalvar" onClick={temporizar}>
          Salvar
        </button>
      </div>
      <div id="Lista-agendados">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;